!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("prop-types"), require("classnames"), require("date-fns/isDate"), require("date-fns/isValid"), require("date-fns/format"), require("date-fns/addMinutes"), require("date-fns/addHours"), require("date-fns/addDays"), require("date-fns/addWeeks"), require("date-fns/addMonths"), require("date-fns/addYears"), require("date-fns/subMinutes"), require("date-fns/subHours"), require("date-fns/subDays"), require("date-fns/subWeeks"), require("date-fns/subMonths"), require("date-fns/subYears"), require("date-fns/getSeconds"), require("date-fns/getMinutes"), require("date-fns/getHours"), require("date-fns/getDay"), require("date-fns/getDate"), require("date-fns/getISOWeek"), require("date-fns/getMonth"), require("date-fns/getQuarter"), require("date-fns/getYear"), require("date-fns/getTime"), require("date-fns/setSeconds"), require("date-fns/setMinutes"), require("date-fns/setHours"), require("date-fns/setMonth"), require("date-fns/setQuarter"), require("date-fns/setYear"), require("date-fns/min"), require("date-fns/max"), require("date-fns/differenceInCalendarDays"), require("date-fns/differenceInCalendarMonths"), require("date-fns/differenceInCalendarWeeks"), require("date-fns/differenceInCalendarYears"), require("date-fns/startOfDay"), require("date-fns/startOfWeek"), require("date-fns/startOfMonth"), require("date-fns/startOfQuarter"), require("date-fns/startOfYear"), require("date-fns/endOfDay"), require("date-fns/endOfWeek"), require("date-fns/endOfMonth"), require("date-fns/endOfYear"), require("date-fns/isEqual"), require("date-fns/isSameDay"), require("date-fns/isSameMonth"), require("date-fns/isSameYear"), require("date-fns/isSameQuarter"), require("date-fns/isAfter"), require("date-fns/isBefore"), require("date-fns/isWithinInterval"), require("date-fns/toDate"), require("date-fns/parse"), require("date-fns/parseISO"), require("react-onclickoutside"), require("react-dom"), require("react-popper"), require("date-fns/set")) : "function" == typeof define && define.amd ? define(["exports", "react", "prop-types", "classnames", "date-fns/isDate", "date-fns/isValid", "date-fns/format", "date-fns/addMinutes", "date-fns/addHours", "date-fns/addDays", "date-fns/addWeeks", "date-fns/addMonths", "date-fns/addYears", "date-fns/subMinutes", "date-fns/subHours", "date-fns/subDays", "date-fns/subWeeks", "date-fns/subMonths", "date-fns/subYears", "date-fns/getSeconds", "date-fns/getMinutes", "date-fns/getHours", "date-fns/getDay", "date-fns/getDate", "date-fns/getISOWeek", "date-fns/getMonth", "date-fns/getQuarter", "date-fns/getYear", "date-fns/getTime", "date-fns/setSeconds", "date-fns/setMinutes", "date-fns/setHours", "date-fns/setMonth", "date-fns/setQuarter", "date-fns/setYear", "date-fns/min", "date-fns/max", "date-fns/differenceInCalendarDays", "date-fns/differenceInCalendarMonths", "date-fns/differenceInCalendarWeeks", "date-fns/differenceInCalendarYears", "date-fns/startOfDay", "date-fns/startOfWeek", "date-fns/startOfMonth", "date-fns/startOfQuarter", "date-fns/startOfYear", "date-fns/endOfDay", "date-fns/endOfWeek", "date-fns/endOfMonth", "date-fns/endOfYear", "date-fns/isEqual", "date-fns/isSameDay", "date-fns/isSameMonth", "date-fns/isSameYear", "date-fns/isSameQuarter", "date-fns/isAfter", "date-fns/isBefore", "date-fns/isWithinInterval", "date-fns/toDate", "date-fns/parse", "date-fns/parseISO", "react-onclickoutside", "react-dom", "react-popper", "date-fns/set"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).DatePicker = {}, e.React, e.PropTypes, e.classNames, e.isDate, e.isValidDate, e.format, e.addMinutes, e.addHours, e.addDays, e.addWeeks, e.addMonths, e.addYears, null, null, e.subDays, e.subWeeks, e.subMonths, e.subYears, e.getSeconds, e.getMinutes, e.getHours, e.getDay, e.getDate, e.getISOWeek, e.getMonth, e.getQuarter, e.getYear, e.getTime, e.setSeconds, e.setMinutes, e.setHours, e.setMonth, e.setQuarter, e.setYear, e.min, e.max, e.differenceInCalendarDays, e.differenceInCalendarMonths, null, e.differenceInCalendarYears, e.startOfDay, e.startOfWeek, e.startOfMonth, e.startOfQuarter, e.startOfYear, e.endOfDay, null, e.endOfMonth, e.endOfYear, e.dfIsEqual, e.dfIsSameDay, e.dfIsSameMonth, e.dfIsSameYear, e.dfIsSameQuarter, e.isAfter, e.isBefore, e.isWithinInterval, e.toDate, e.parse, e.parseISO, e.onClickOutside, e.ReactDOM, e.ReactPopper, e.set);
}(this, function (e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, v, D, g, w, k, b, S, C, _, M, P, E, N, O, x, Y, I, T, L, R, F, A, q, W, B, K, j, H, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe, le, de) {
  "use strict";

  function ce(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var ue = ce(t),
      fe = ce(a),
      he = ce(n),
      me = ce(o),
      ye = ce(s),
      ve = ce(i),
      De = ce(p),
      ge = ce(l),
      we = ce(d),
      ke = ce(c),
      be = ce(u),
      Se = ce(m),
      Ce = ce(y),
      _e = ce(v),
      Me = ce(D),
      Pe = ce(g),
      Ee = ce(w),
      Ne = ce(k),
      Oe = ce(b),
      xe = ce(S),
      Ye = ce(C),
      Ie = ce(_),
      Te = ce(M),
      Le = ce(P),
      Re = ce(E),
      Fe = ce(N),
      Ae = ce(O),
      qe = ce(x),
      We = ce(Y),
      Be = ce(I),
      Ke = ce(T),
      je = ce(L),
      He = ce(R),
      Qe = ce(F),
      Ve = ce(A),
      Ue = ce(W),
      $e = ce(B),
      ze = ce(K),
      Ge = ce(j),
      Je = ce(H),
      Xe = ce(Q),
      Ze = ce(V),
      et = ce($),
      tt = ce(z),
      rt = ce(G),
      at = ce(J),
      nt = ce(X),
      ot = ce(Z),
      st = ce(ee),
      it = ce(te),
      pt = ce(re),
      lt = ce(ae),
      dt = ce(ne),
      ct = ce(oe),
      ut = ce(se),
      ft = ce(ie),
      ht = ce(pe),
      mt = ce(de);

  function yt(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      t && (a = a.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, a);
    }

    return r;
  }

  function vt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? yt(Object(r), !0).forEach(function (t) {
        bt(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yt(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function Dt(e) {
    return (Dt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function gt(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function wt(e, t) {
    for (var r = 0; r < t.length; r++) {
      var a = t[r];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, Yt(a.key), a);
    }
  }

  function kt(e, t, r) {
    return t && wt(e.prototype, t), r && wt(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }

  function bt(e, t, r) {
    return (t = Yt(t)) in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function St() {
    return (St = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
      }

      return e;
    }).apply(this, arguments);
  }

  function Ct(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && Mt(e, t);
  }

  function _t(e) {
    return (_t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function Mt(e, t) {
    return (Mt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Pt(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function Et(e, t) {
    if (t && ("object" == typeof t || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return Pt(e);
  }

  function Nt(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var r,
          a = _t(e);

      if (t) {
        var n = _t(this).constructor;

        r = Reflect.construct(a, arguments, n);
      } else r = a.apply(this, arguments);

      return Et(this, r);
    };
  }

  function Ot(e) {
    return function (e) {
      if (Array.isArray(e)) return xt(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return xt(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return xt(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function xt(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];

    return a;
  }

  function Yt(e) {
    var t = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var r = e[Symbol.toPrimitive];

      if (void 0 !== r) {
        var a = r.call(e, t || "default");
        if ("object" != typeof a) return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === t ? String : Number)(e);
    }(e, "string");

    return "symbol" == typeof t ? t : String(t);
  }

  var It = 12;

  function Tt(e) {
    var t = e ? "string" == typeof e || e instanceof String ? ut.default(e) : dt.default(e) : new Date();
    return Rt(t) ? t : null;
  }

  function Lt(e, t, r, a, n) {
    var o = tr(r) || tr(er()),
        s = Array.isArray(t) ? t : [t];
    n = n || Tt();

    for (var i = 0, p = s.length; i < p; i++) {
      var l = s[i],
          d = ct.default(e, l, n, {
        locale: o
      });
      if (Rt(d) && (!a || e === Ft(d, l, r))) return d;
    }

    return null;
  }

  function Rt(e, t) {
    return t = t || new Date("1/1/1000"), me.default(e) && !pt.default(e, t);
  }

  function Ft(e, t, r) {
    if ("en" === r) return ye.default(e, t, {
      awareOfUnicodeTokens: !0
    });
    var a = tr(r) || tr(er()) || null;
    return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), ye.default(e, t, {
      locale: a,
      awareOfUnicodeTokens: !0
    });
  }

  function At(e, t) {
    var r = t.dateFormat,
        a = t.locale;
    return e && Ft(e, Array.isArray(r) ? r[0] : r, a) || "";
  }

  function qt(e, t) {
    var r = t.hour,
        a = void 0 === r ? 0 : r,
        n = t.minute,
        o = void 0 === n ? 0 : n,
        s = t.second,
        i = void 0 === s ? 0 : s;
    return qe.default(Ae.default(Fe.default(e, i), o), a);
  }

  function Wt(e, t) {
    var r = t && tr(t) || er() && tr(er());
    return Ye.default(e, r ? {
      locale: r
    } : null);
  }

  function Bt(e, t) {
    return Ft(e, "ddd", t);
  }

  function Kt(e) {
    return $e.default(e);
  }

  function jt(e, t, r) {
    var a = tr(t || er());
    return ze.default(e, {
      locale: a,
      weekStartsOn: r
    });
  }

  function Ht(e) {
    return Ge.default(e);
  }

  function Qt(e) {
    return Xe.default(e);
  }

  function Vt(e) {
    return Je.default(e);
  }

  function Ut() {
    return $e.default(Tt());
  }

  function $t(e, t) {
    return e && t ? ot.default(e, t) : !e && !t;
  }

  function zt(e, t) {
    return e && t ? nt.default(e, t) : !e && !t;
  }

  function Gt(e, t) {
    return e && t ? st.default(e, t) : !e && !t;
  }

  function Jt(e, t) {
    return e && t ? at.default(e, t) : !e && !t;
  }

  function Xt(e, t) {
    return e && t ? rt.default(e, t) : !e && !t;
  }

  function Zt(e, t, r) {
    var a,
        n = $e.default(t),
        o = Ze.default(r);

    try {
      a = lt.default(e, {
        start: n,
        end: o
      });
    } catch (e) {
      a = !1;
    }

    return a;
  }

  function er() {
    return ("undefined" != typeof window ? window : globalThis).__localeId__;
  }

  function tr(e) {
    if ("string" == typeof e) {
      var t = "undefined" != typeof window ? window : globalThis;
      return t.__localeData__ ? t.__localeData__[e] : null;
    }

    return e;
  }

  function rr(e, t) {
    return Ft(We.default(Tt(), e), "LLLL", t);
  }

  function ar(e, t) {
    return Ft(We.default(Tt(), e), "LLL", t);
  }

  function nr(e, t) {
    return Ft(Be.default(Tt(), e), "QQQ", t);
  }

  function or(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.maxDate,
        n = t.excludeDates,
        o = t.excludeDateIntervals,
        s = t.includeDates,
        i = t.includeDateIntervals,
        p = t.filterDate;
    return ur(e, {
      minDate: r,
      maxDate: a
    }) || n && n.some(function (t) {
      return Jt(e, t);
    }) || o && o.some(function (t) {
      var r = t.start,
          a = t.end;
      return lt.default(e, {
        start: r,
        end: a
      });
    }) || s && !s.some(function (t) {
      return Jt(e, t);
    }) || i && !i.some(function (t) {
      var r = t.start,
          a = t.end;
      return lt.default(e, {
        start: r,
        end: a
      });
    }) || p && !p(Tt(e)) || !1;
  }

  function sr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.excludeDates,
        a = t.excludeDateIntervals;
    return a && a.length > 0 ? a.some(function (t) {
      var r = t.start,
          a = t.end;
      return lt.default(e, {
        start: r,
        end: a
      });
    }) : r && r.some(function (t) {
      return Jt(e, t);
    }) || !1;
  }

  function ir(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.maxDate,
        n = t.excludeDates,
        o = t.includeDates,
        s = t.filterDate;
    return ur(e, {
      minDate: Ge.default(r),
      maxDate: et.default(a)
    }) || n && n.some(function (t) {
      return zt(e, t);
    }) || o && !o.some(function (t) {
      return zt(e, t);
    }) || s && !s(Tt(e)) || !1;
  }

  function pr(e, t, r, a) {
    var n = Le.default(e),
        o = Ie.default(e),
        s = Le.default(t),
        i = Ie.default(t),
        p = Le.default(a);
    return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
  }

  function lr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.maxDate,
        n = t.excludeDates,
        o = t.includeDates,
        s = t.filterDate;
    return ur(e, {
      minDate: r,
      maxDate: a
    }) || n && n.some(function (t) {
      return Gt(e, t);
    }) || o && !o.some(function (t) {
      return Gt(e, t);
    }) || s && !s(Tt(e)) || !1;
  }

  function dr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.maxDate,
        n = t.excludeDates,
        o = t.includeDates,
        s = t.filterDate,
        i = new Date(e, 0, 1);
    return ur(i, {
      minDate: Xe.default(r),
      maxDate: tt.default(a)
    }) || n && n.some(function (e) {
      return $t(i, e);
    }) || o && !o.some(function (e) {
      return $t(i, e);
    }) || s && !s(Tt(i)) || !1;
  }

  function cr(e, t, r, a) {
    var n = Le.default(e),
        o = Te.default(e),
        s = Le.default(t),
        i = Te.default(t),
        p = Le.default(a);
    return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
  }

  function ur(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.maxDate;
    return r && Qe.default(e, r) < 0 || a && Qe.default(e, a) > 0;
  }

  function fr(e, t) {
    return t.some(function (t) {
      return Ne.default(t) === Ne.default(e) && Ee.default(t) === Ee.default(e);
    });
  }

  function hr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.excludeTimes,
        a = t.includeTimes,
        n = t.filterTime;
    return r && fr(e, r) || a && !fr(e, a) || n && !n(e) || !1;
  }

  function mr(e, t) {
    var r = t.minTime,
        a = t.maxTime;
    if (!r || !a) throw new Error("Both minTime and maxTime props required");
    var n,
        o = Tt(),
        s = qe.default(Ae.default(o, Ee.default(e)), Ne.default(e)),
        i = qe.default(Ae.default(o, Ee.default(r)), Ne.default(r)),
        p = qe.default(Ae.default(o, Ee.default(a)), Ne.default(a));

    try {
      n = !lt.default(s, {
        start: i,
        end: p
      });
    } catch (e) {
      n = !1;
    }

    return n;
  }

  function yr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.includeDates,
        n = _e.default(e, 1);

    return r && Ve.default(r, n) > 0 || a && a.every(function (e) {
      return Ve.default(e, n) > 0;
    }) || !1;
  }

  function vr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.maxDate,
        a = t.includeDates,
        n = ke.default(e, 1);
    return r && Ve.default(n, r) > 0 || a && a.every(function (e) {
      return Ve.default(n, e) > 0;
    }) || !1;
  }

  function Dr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        a = t.includeDates,
        n = Me.default(e, 1);
    return r && Ue.default(r, n) > 0 || a && a.every(function (e) {
      return Ue.default(e, n) > 0;
    }) || !1;
  }

  function gr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.maxDate,
        a = t.includeDates,
        n = be.default(e, 1);
    return r && Ue.default(n, r) > 0 || a && a.every(function (e) {
      return Ue.default(n, e) > 0;
    }) || !1;
  }

  function wr(e) {
    var t = e.minDate,
        r = e.includeDates;

    if (r && t) {
      var a = r.filter(function (e) {
        return Qe.default(e, t) >= 0;
      });
      return je.default(a);
    }

    return r ? je.default(r) : t;
  }

  function kr(e) {
    var t = e.maxDate,
        r = e.includeDates;

    if (r && t) {
      var a = r.filter(function (e) {
        return Qe.default(e, t) <= 0;
      });
      return He.default(a);
    }

    return r ? He.default(r) : t;
  }

  function br() {
    for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map(), a = 0, n = e.length; a < n; a++) {
      var o = e[a];

      if (he.default(o)) {
        var s = Ft(o, "MM.dd.yyyy"),
            i = r.get(s) || [];
        i.includes(t) || (i.push(t), r.set(s, i));
      } else if ("object" === Dt(o)) {
        var p = Object.keys(o),
            l = p[0],
            d = o[p[0]];
        if ("string" == typeof l && d.constructor === Array) for (var c = 0, u = d.length; c < u; c++) {
          var f = Ft(d[c], "MM.dd.yyyy"),
              h = r.get(f) || [];
          h.includes(l) || (h.push(l), r.set(f, h));
        }
      }
    }

    return r;
  }

  function Sr(e, t, r, a, n) {
    for (var o = n.length, s = [], i = 0; i < o; i++) {
      var p = ve.default(De.default(e, Ne.default(n[i])), Ee.default(n[i])),
          l = ve.default(e, (r + 1) * a);
      it.default(p, t) && pt.default(p, l) && s.push(n[i]);
    }

    return s;
  }

  function Cr(e) {
    return e < 10 ? "0".concat(e) : "".concat(e);
  }

  function _r(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : It,
        r = Math.ceil(Le.default(e) / t) * t,
        a = r - (t - 1);
    return {
      startPeriod: a,
      endPeriod: r
    };
  }

  function Mr(e, t, r, a) {
    for (var n = [], o = 0; o < 2 * t + 1; o++) {
      var s = e + t - o,
          i = !0;
      r && (i = Le.default(r) <= s), a && i && (i = Le.default(a) >= s), i && n.push(s);
    }

    return n;
  }

  var Pr = function (e) {
    Ct(a, e);
    var r = Nt(a);

    function a(e) {
      var n;
      gt(this, a), bt(Pt(n = r.call(this, e)), "renderOptions", function () {
        var e = n.props.year,
            t = n.state.yearsList.map(function (t) {
          return ue.default.createElement("div", {
            className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: t,
            onClick: n.onChange.bind(Pt(n), t),
            "aria-selected": e === t ? "true" : void 0
          }, e === t ? ue.default.createElement("span", {
            className: "react-datepicker__year-option--selected"
          }, "✓") : "", t);
        }),
            r = n.props.minDate ? Le.default(n.props.minDate) : null,
            a = n.props.maxDate ? Le.default(n.props.maxDate) : null;
        return a && n.state.yearsList.find(function (e) {
          return e === a;
        }) || t.unshift(ue.default.createElement("div", {
          className: "react-datepicker__year-option",
          key: "upcoming",
          onClick: n.incrementYears
        }, ue.default.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
        }))), r && n.state.yearsList.find(function (e) {
          return e === r;
        }) || t.push(ue.default.createElement("div", {
          className: "react-datepicker__year-option",
          key: "previous",
          onClick: n.decrementYears
        }, ue.default.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
        }))), t;
      }), bt(Pt(n), "onChange", function (e) {
        n.props.onChange(e);
      }), bt(Pt(n), "handleClickOutside", function () {
        n.props.onCancel();
      }), bt(Pt(n), "shiftYears", function (e) {
        var t = n.state.yearsList.map(function (t) {
          return t + e;
        });
        n.setState({
          yearsList: t
        });
      }), bt(Pt(n), "incrementYears", function () {
        return n.shiftYears(1);
      }), bt(Pt(n), "decrementYears", function () {
        return n.shiftYears(-1);
      });
      var o = e.yearDropdownItemNumber,
          s = e.scrollableYearDropdown,
          i = o || (s ? 10 : 5);
      return n.state = {
        yearsList: Mr(n.props.year, i, n.props.minDate, n.props.maxDate)
      }, n.dropdownRef = t.createRef(), n;
    }

    return kt(a, [{
      key: "componentDidMount",
      value: function () {
        var e = this.dropdownRef.current;
        e && (e.scrollTop = e.scrollHeight / 2 - e.clientHeight / 2);
      }
    }, {
      key: "render",
      value: function () {
        var e = fe.default({
          "react-datepicker__year-dropdown": !0,
          "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return ue.default.createElement("div", {
          className: e,
          ref: this.dropdownRef
        }, this.renderOptions());
      }
    }]), a;
  }(ue.default.Component),
      Er = ft.default(Pr),
      Nr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "state", {
        dropdownVisible: !1
      }), bt(Pt(e), "renderSelectOptions", function () {
        for (var t = e.props.minDate ? Le.default(e.props.minDate) : 1900, r = e.props.maxDate ? Le.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++) a.push(ue.default.createElement("option", {
          key: n,
          value: n
        }, n));

        return a;
      }), bt(Pt(e), "onSelectChange", function (t) {
        e.onChange(t.target.value);
      }), bt(Pt(e), "renderSelectMode", function () {
        return ue.default.createElement("select", {
          value: e.props.year,
          className: "react-datepicker__year-select",
          onChange: e.onSelectChange
        }, e.renderSelectOptions());
      }), bt(Pt(e), "renderReadView", function (t) {
        return ue.default.createElement("div", {
          key: "read",
          style: {
            visibility: t ? "visible" : "hidden"
          },
          className: "react-datepicker__year-read-view",
          onClick: function (t) {
            return e.toggleDropdown(t);
          }
        }, ue.default.createElement("span", {
          className: "react-datepicker__year-read-view--down-arrow"
        }), ue.default.createElement("span", {
          className: "react-datepicker__year-read-view--selected-year"
        }, e.props.year));
      }), bt(Pt(e), "renderDropdown", function () {
        return ue.default.createElement(Er, {
          key: "dropdown",
          year: e.props.year,
          onChange: e.onChange,
          onCancel: e.toggleDropdown,
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          scrollableYearDropdown: e.props.scrollableYearDropdown,
          yearDropdownItemNumber: e.props.yearDropdownItemNumber
        });
      }), bt(Pt(e), "renderScrollMode", function () {
        var t = e.state.dropdownVisible,
            r = [e.renderReadView(!t)];
        return t && r.unshift(e.renderDropdown()), r;
      }), bt(Pt(e), "onChange", function (t) {
        e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
      }), bt(Pt(e), "toggleDropdown", function (t) {
        e.setState({
          dropdownVisible: !e.state.dropdownVisible
        }, function () {
          e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
        });
      }), bt(Pt(e), "handleYearChange", function (t, r) {
        e.onSelect(t, r), e.setOpen();
      }), bt(Pt(e), "onSelect", function (t, r) {
        e.props.onSelect && e.props.onSelect(t, r);
      }), bt(Pt(e), "setOpen", function () {
        e.props.setOpen && e.props.setOpen(!0);
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e;

        switch (this.props.dropdownMode) {
          case "scroll":
            e = this.renderScrollMode();
            break;

          case "select":
            e = this.renderSelectMode();
        }

        return ue.default.createElement("div", {
          className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, e);
      }
    }]), r;
  }(ue.default.Component),
      Or = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "isSelectedMonth", function (t) {
        return e.props.month === t;
      }), bt(Pt(e), "renderOptions", function () {
        return e.props.monthNames.map(function (t, r) {
          return ue.default.createElement("div", {
            className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
            key: t,
            onClick: e.onChange.bind(Pt(e), r),
            "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
          }, e.isSelectedMonth(r) ? ue.default.createElement("span", {
            className: "react-datepicker__month-option--selected"
          }, "✓") : "", t);
        });
      }), bt(Pt(e), "onChange", function (t) {
        return e.props.onChange(t);
      }), bt(Pt(e), "handleClickOutside", function () {
        return e.props.onCancel();
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        return ue.default.createElement("div", {
          className: "react-datepicker__month-dropdown"
        }, this.renderOptions());
      }
    }]), r;
  }(ue.default.Component),
      xr = ft.default(Or),
      Yr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "state", {
        dropdownVisible: !1
      }), bt(Pt(e), "renderSelectOptions", function (e) {
        return e.map(function (e, t) {
          return ue.default.createElement("option", {
            key: t,
            value: t
          }, e);
        });
      }), bt(Pt(e), "renderSelectMode", function (t) {
        return ue.default.createElement("select", {
          value: e.props.month,
          className: "react-datepicker__month-select",
          onChange: function (t) {
            return e.onChange(t.target.value);
          }
        }, e.renderSelectOptions(t));
      }), bt(Pt(e), "renderReadView", function (t, r) {
        return ue.default.createElement("div", {
          key: "read",
          style: {
            visibility: t ? "visible" : "hidden"
          },
          className: "react-datepicker__month-read-view",
          onClick: e.toggleDropdown
        }, ue.default.createElement("span", {
          className: "react-datepicker__month-read-view--down-arrow"
        }), ue.default.createElement("span", {
          className: "react-datepicker__month-read-view--selected-month"
        }, r[e.props.month]));
      }), bt(Pt(e), "renderDropdown", function (t) {
        return ue.default.createElement(xr, {
          key: "dropdown",
          month: e.props.month,
          monthNames: t,
          onChange: e.onChange,
          onCancel: e.toggleDropdown
        });
      }), bt(Pt(e), "renderScrollMode", function (t) {
        var r = e.state.dropdownVisible,
            a = [e.renderReadView(!r, t)];
        return r && a.unshift(e.renderDropdown(t)), a;
      }), bt(Pt(e), "onChange", function (t) {
        e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
      }), bt(Pt(e), "toggleDropdown", function () {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e,
            t = this,
            r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (e) {
          return ar(e, t.props.locale);
        } : function (e) {
          return rr(e, t.props.locale);
        });

        switch (this.props.dropdownMode) {
          case "scroll":
            e = this.renderScrollMode(r);
            break;

          case "select":
            e = this.renderSelectMode(r);
        }

        return ue.default.createElement("div", {
          className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, e);
      }
    }]), r;
  }(ue.default.Component);

  function Ir(e, t) {
    for (var r = [], a = Ht(e), n = Ht(t); !it.default(a, n);) r.push(Tt(a)), a = ke.default(a, 1);

    return r;
  }

  var Tr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), bt(Pt(a = t.call(this, e)), "renderOptions", function () {
        return a.state.monthYearsList.map(function (e) {
          var t = Re.default(e),
              r = $t(a.props.date, e) && zt(a.props.date, e);
          return ue.default.createElement("div", {
            className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
            key: t,
            onClick: a.onChange.bind(Pt(a), t),
            "aria-selected": r ? "true" : void 0
          }, r ? ue.default.createElement("span", {
            className: "react-datepicker__month-year-option--selected"
          }, "✓") : "", Ft(e, a.props.dateFormat, a.props.locale));
        });
      }), bt(Pt(a), "onChange", function (e) {
        return a.props.onChange(e);
      }), bt(Pt(a), "handleClickOutside", function () {
        a.props.onCancel();
      }), a.state = {
        monthYearsList: Ir(a.props.minDate, a.props.maxDate)
      }, a;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e = fe.default({
          "react-datepicker__month-year-dropdown": !0,
          "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return ue.default.createElement("div", {
          className: e
        }, this.renderOptions());
      }
    }]), r;
  }(ue.default.Component),
      Lr = ft.default(Tr),
      Rr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "state", {
        dropdownVisible: !1
      }), bt(Pt(e), "renderSelectOptions", function () {
        for (var t = Ht(e.props.minDate), r = Ht(e.props.maxDate), a = []; !it.default(t, r);) {
          var n = Re.default(t);
          a.push(ue.default.createElement("option", {
            key: n,
            value: n
          }, Ft(t, e.props.dateFormat, e.props.locale))), t = ke.default(t, 1);
        }

        return a;
      }), bt(Pt(e), "onSelectChange", function (t) {
        e.onChange(t.target.value);
      }), bt(Pt(e), "renderSelectMode", function () {
        return ue.default.createElement("select", {
          value: Re.default(Ht(e.props.date)),
          className: "react-datepicker__month-year-select",
          onChange: e.onSelectChange
        }, e.renderSelectOptions());
      }), bt(Pt(e), "renderReadView", function (t) {
        var r = Ft(e.props.date, e.props.dateFormat, e.props.locale);
        return ue.default.createElement("div", {
          key: "read",
          style: {
            visibility: t ? "visible" : "hidden"
          },
          className: "react-datepicker__month-year-read-view",
          onClick: function (t) {
            return e.toggleDropdown(t);
          }
        }, ue.default.createElement("span", {
          className: "react-datepicker__month-year-read-view--down-arrow"
        }), ue.default.createElement("span", {
          className: "react-datepicker__month-year-read-view--selected-month-year"
        }, r));
      }), bt(Pt(e), "renderDropdown", function () {
        return ue.default.createElement(Lr, {
          key: "dropdown",
          date: e.props.date,
          dateFormat: e.props.dateFormat,
          onChange: e.onChange,
          onCancel: e.toggleDropdown,
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
          locale: e.props.locale
        });
      }), bt(Pt(e), "renderScrollMode", function () {
        var t = e.state.dropdownVisible,
            r = [e.renderReadView(!t)];
        return t && r.unshift(e.renderDropdown()), r;
      }), bt(Pt(e), "onChange", function (t) {
        e.toggleDropdown();
        var r = Tt(parseInt(t));
        $t(e.props.date, r) && zt(e.props.date, r) || e.props.onChange(r);
      }), bt(Pt(e), "toggleDropdown", function () {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e;

        switch (this.props.dropdownMode) {
          case "scroll":
            e = this.renderScrollMode();
            break;

          case "select":
            e = this.renderSelectMode();
        }

        return ue.default.createElement("div", {
          className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, e);
      }
    }]), r;
  }(ue.default.Component),
      Fr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "dayEl", ue.default.createRef()), bt(Pt(e), "handleClick", function (t) {
        !e.isDisabled() && e.props.onClick && e.props.onClick(t);
      }), bt(Pt(e), "handleMouseEnter", function (t) {
        !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
      }), bt(Pt(e), "handleOnKeyDown", function (t) {
        " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
      }), bt(Pt(e), "isSameDay", function (t) {
        return Jt(e.props.day, t);
      }), bt(Pt(e), "isKeyboardSelected", function () {
        return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
      }), bt(Pt(e), "isDisabled", function () {
        return or(e.props.day, e.props);
      }), bt(Pt(e), "isExcluded", function () {
        return sr(e.props.day, e.props);
      }), bt(Pt(e), "getHighLightedClass", function (t) {
        var r = e.props,
            a = r.day,
            n = r.highlightDates;
        if (!n) return !1;
        var o = Ft(a, "MM.dd.yyyy");
        return n.get(o);
      }), bt(Pt(e), "isInRange", function () {
        var t = e.props,
            r = t.day,
            a = t.startDate,
            n = t.endDate;
        return !(!a || !n) && Zt(r, a, n);
      }), bt(Pt(e), "isInSelectingRange", function () {
        var t,
            r = e.props,
            a = r.day,
            n = r.selectsStart,
            o = r.selectsEnd,
            s = r.selectsRange,
            i = r.selectsDisabledDaysInRange,
            p = r.startDate,
            l = r.endDate,
            d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
        return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (pt.default(d, l) || Xt(d, l)) ? Zt(a, d, l) : (o && p && (it.default(d, p) || Xt(d, p)) || !(!s || !p || l || !it.default(d, p) && !Xt(d, p))) && Zt(a, p, d));
      }), bt(Pt(e), "isSelectingRangeStart", function () {
        var t;
        if (!e.isInSelectingRange()) return !1;
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.selectsStart,
            s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
        return Jt(a, o ? s : n);
      }), bt(Pt(e), "isSelectingRangeEnd", function () {
        var t;
        if (!e.isInSelectingRange()) return !1;
        var r = e.props,
            a = r.day,
            n = r.endDate,
            o = r.selectsEnd,
            s = r.selectsRange,
            i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
        return Jt(a, o || s ? i : n);
      }), bt(Pt(e), "isRangeStart", function () {
        var t = e.props,
            r = t.day,
            a = t.startDate,
            n = t.endDate;
        return !(!a || !n) && Jt(a, r);
      }), bt(Pt(e), "isRangeEnd", function () {
        var t = e.props,
            r = t.day,
            a = t.startDate,
            n = t.endDate;
        return !(!a || !n) && Jt(n, r);
      }), bt(Pt(e), "isWeekend", function () {
        var t = Oe.default(e.props.day);
        return 0 === t || 6 === t;
      }), bt(Pt(e), "isAfterMonth", function () {
        return void 0 !== e.props.month && (e.props.month + 1) % 12 === Ie.default(e.props.day);
      }), bt(Pt(e), "isBeforeMonth", function () {
        return void 0 !== e.props.month && (Ie.default(e.props.day) + 1) % 12 === e.props.month;
      }), bt(Pt(e), "isCurrentDay", function () {
        return e.isSameDay(Tt());
      }), bt(Pt(e), "isSelected", function () {
        return e.isSameDay(e.props.selected);
      }), bt(Pt(e), "getClassNames", function (t) {
        var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
        return fe.default("react-datepicker__day", r, "react-datepicker__day--" + Bt(e.props.day), {
          "react-datepicker__day--disabled": e.isDisabled(),
          "react-datepicker__day--excluded": e.isExcluded(),
          "react-datepicker__day--selected": e.isSelected(),
          "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
          "react-datepicker__day--range-start": e.isRangeStart(),
          "react-datepicker__day--range-end": e.isRangeEnd(),
          "react-datepicker__day--in-range": e.isInRange(),
          "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
          "react-datepicker__day--today": e.isCurrentDay(),
          "react-datepicker__day--weekend": e.isWeekend(),
          "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
        }, e.getHighLightedClass("react-datepicker__day--highlighted"));
      }), bt(Pt(e), "getAriaLabel", function () {
        var t = e.props,
            r = t.day,
            a = t.ariaLabelPrefixWhenEnabled,
            n = void 0 === a ? "Choose" : a,
            o = t.ariaLabelPrefixWhenDisabled,
            s = void 0 === o ? "Not available" : o,
            i = e.isDisabled() || e.isExcluded() ? s : n;
        return "".concat(i, " ").concat(Ft(r, "PPPP", e.props.locale));
      }), bt(Pt(e), "getTabIndex", function (t, r) {
        var a = t || e.props.selected,
            n = r || e.props.preSelection;
        return e.isKeyboardSelected() || e.isSameDay(a) && Jt(n, a) ? 0 : -1;
      }), bt(Pt(e), "handleFocusDay", function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = !1;
        0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
          preventScroll: !0
        });
      }), bt(Pt(e), "renderDayContents", function () {
        return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(xe.default(e.props.day), e.props.day) : xe.default(e.props.day);
      }), bt(Pt(e), "render", function () {
        return ue.default.createElement("div", {
          ref: e.dayEl,
          className: e.getClassNames(e.props.day),
          onKeyDown: e.handleOnKeyDown,
          onClick: e.handleClick,
          onMouseEnter: e.handleMouseEnter,
          tabIndex: e.getTabIndex(),
          "aria-label": e.getAriaLabel(),
          role: "option",
          "aria-disabled": e.isDisabled(),
          "aria-current": e.isCurrentDay() ? "date" : void 0,
          "aria-selected": e.isSelected()
        }, e.renderDayContents());
      }), e;
    }

    return kt(r, [{
      key: "componentDidMount",
      value: function () {
        this.handleFocusDay();
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        this.handleFocusDay(e);
      }
    }]), r;
  }(ue.default.Component),
      Ar = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "handleClick", function (t) {
        e.props.onClick && e.props.onClick(t);
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e = this.props,
            t = e.weekNumber,
            r = e.ariaLabelPrefix,
            a = void 0 === r ? "week " : r,
            n = {
          "react-datepicker__week-number": !0,
          "react-datepicker__week-number--clickable": !!e.onClick
        };
        return ue.default.createElement("div", {
          className: fe.default(n),
          "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
          onClick: this.handleClick
        }, t);
      }
    }]), r;
  }(ue.default.Component),
      qr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "handleDayClick", function (t, r) {
        e.props.onDayClick && e.props.onDayClick(t, r);
      }), bt(Pt(e), "handleDayMouseEnter", function (t) {
        e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
      }), bt(Pt(e), "handleWeekClick", function (t, r, a) {
        "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
      }), bt(Pt(e), "formatWeekNumber", function (t) {
        return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : Wt(t);
      }), bt(Pt(e), "renderDays", function () {
        var t = jt(e.props.day, e.props.locale, e.props.calendarStartDay),
            r = [],
            a = e.formatWeekNumber(t);

        if (e.props.showWeekNumber) {
          var n = e.props.onWeekSelect ? e.handleWeekClick.bind(Pt(e), t, a) : void 0;
          r.push(ue.default.createElement(Ar, {
            key: "W",
            weekNumber: a,
            onClick: n,
            ariaLabelPrefix: e.props.ariaLabelPrefix
          }));
        }

        return r.concat([0, 1, 2, 3, 4, 5, 6].map(function (r) {
          var a = ge.default(t, r);
          return ue.default.createElement(Fr, {
            ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
            ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
            key: a.valueOf(),
            day: a,
            month: e.props.month,
            onClick: e.handleDayClick.bind(Pt(e), a),
            onMouseEnter: e.handleDayMouseEnter.bind(Pt(e), a),
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            excludeDates: e.props.excludeDates,
            excludeDateIntervals: e.props.excludeDateIntervals,
            includeDates: e.props.includeDates,
            includeDateIntervals: e.props.includeDateIntervals,
            highlightDates: e.props.highlightDates,
            selectingDate: e.props.selectingDate,
            filterDate: e.props.filterDate,
            preSelection: e.props.preSelection,
            selected: e.props.selected,
            selectsStart: e.props.selectsStart,
            selectsEnd: e.props.selectsEnd,
            selectsRange: e.props.selectsRange,
            selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
            startDate: e.props.startDate,
            endDate: e.props.endDate,
            dayClassName: e.props.dayClassName,
            renderDayContents: e.props.renderDayContents,
            disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
            handleOnKeyDown: e.props.handleOnKeyDown,
            isInputFocused: e.props.isInputFocused,
            containerRef: e.props.containerRef,
            inline: e.props.inline,
            shouldFocusDayInline: e.props.shouldFocusDayInline,
            monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
            monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
            locale: e.props.locale
          });
        }));
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        return ue.default.createElement("div", {
          className: "react-datepicker__week"
        }, this.renderDays());
      }
    }], [{
      key: "defaultProps",
      get: function () {
        return {
          shouldCloseOnSelect: !0
        };
      }
    }]), r;
  }(ue.default.Component),
      Wr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "MONTH_REFS", Ot(Array(12)).map(function () {
        return ue.default.createRef();
      })), bt(Pt(e), "isDisabled", function (t) {
        return or(t, e.props);
      }), bt(Pt(e), "isExcluded", function (t) {
        return sr(t, e.props);
      }), bt(Pt(e), "handleDayClick", function (t, r) {
        e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
      }), bt(Pt(e), "handleDayMouseEnter", function (t) {
        e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
      }), bt(Pt(e), "handleMouseLeave", function () {
        e.props.onMouseLeave && e.props.onMouseLeave();
      }), bt(Pt(e), "isRangeStartMonth", function (t) {
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
        return !(!n || !o) && zt(We.default(a, t), n);
      }), bt(Pt(e), "isRangeStartQuarter", function (t) {
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
        return !(!n || !o) && Gt(Be.default(a, t), n);
      }), bt(Pt(e), "isRangeEndMonth", function (t) {
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
        return !(!n || !o) && zt(We.default(a, t), o);
      }), bt(Pt(e), "isRangeEndQuarter", function (t) {
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
        return !(!n || !o) && Gt(Be.default(a, t), o);
      }), bt(Pt(e), "isWeekInMonth", function (t) {
        var r = e.props.day,
            a = ge.default(t, 6);
        return zt(t, r) || zt(a, r);
      }), bt(Pt(e), "isCurrentMonth", function (e, t) {
        return Le.default(e) === Le.default(Tt()) && t === Ie.default(Tt());
      }), bt(Pt(e), "isSelectedMonth", function (e, t, r) {
        return Ie.default(e) === t && Le.default(e) === Le.default(r);
      }), bt(Pt(e), "isSelectedQuarter", function (e, t, r) {
        return Te.default(e) === t && Le.default(e) === Le.default(r);
      }), bt(Pt(e), "renderWeeks", function () {
        for (var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = jt(Ht(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(ue.default.createElement(qr, {
          ariaLabelPrefix: e.props.weekAriaLabelPrefix,
          chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
          key: a,
          day: o,
          month: Ie.default(e.props.day),
          onDayClick: e.handleDayClick,
          onDayMouseEnter: e.handleDayMouseEnter,
          onWeekSelect: e.props.onWeekSelect,
          formatWeekNumber: e.props.formatWeekNumber,
          locale: e.props.locale,
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDates: e.props.includeDates,
          includeDateIntervals: e.props.includeDateIntervals,
          inline: e.props.inline,
          shouldFocusDayInline: e.props.shouldFocusDayInline,
          highlightDates: e.props.highlightDates,
          selectingDate: e.props.selectingDate,
          filterDate: e.props.filterDate,
          preSelection: e.props.preSelection,
          selected: e.props.selected,
          selectsStart: e.props.selectsStart,
          selectsEnd: e.props.selectsEnd,
          selectsRange: e.props.selectsRange,
          selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
          showWeekNumber: e.props.showWeekNumbers,
          startDate: e.props.startDate,
          endDate: e.props.endDate,
          dayClassName: e.props.dayClassName,
          setOpen: e.props.setOpen,
          shouldCloseOnSelect: e.props.shouldCloseOnSelect,
          disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
          renderDayContents: e.props.renderDayContents,
          handleOnKeyDown: e.props.handleOnKeyDown,
          isInputFocused: e.props.isInputFocused,
          containerRef: e.props.containerRef,
          calendarStartDay: e.props.calendarStartDay,
          monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
        })), !n;) {
          a++, o = we.default(o, 1);
          var s = r && a >= 6,
              i = !r && !e.isWeekInMonth(o);

          if (s || i) {
            if (!e.props.peekNextMonth) break;
            n = !0;
          }
        }

        return t;
      }), bt(Pt(e), "onMonthClick", function (t, r) {
        e.handleDayClick(Ht(We.default(e.props.day, r)), t);
      }), bt(Pt(e), "handleMonthNavigation", function (t, r) {
        e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
      }), bt(Pt(e), "onMonthKeyDown", function (t, r) {
        t.preventDefault();
        var a = t.key;
        if (!e.props.disabledKeyboardNavigation) switch (a) {
          case "Enter":
            e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
            break;

          case "ArrowRight":
            e.handleMonthNavigation(11 === r ? 0 : r + 1, ke.default(e.props.preSelection, 1));
            break;

          case "ArrowLeft":
            e.handleMonthNavigation(0 === r ? 11 : r - 1, _e.default(e.props.preSelection, 1));
            break;

          case "ArrowUp":
            e.handleMonthNavigation(r >= 0 && r <= 2 ? r + 9 : r - 3, _e.default(e.props.preSelection, 3));
            break;

          case "ArrowDown":
            e.handleMonthNavigation(r >= 9 && r <= 11 ? r - 9 : r + 3, ke.default(e.props.preSelection, 3));
        }
      }), bt(Pt(e), "onQuarterClick", function (t, r) {
        e.handleDayClick(Vt(Be.default(e.props.day, r)), t);
      }), bt(Pt(e), "getMonthClassNames", function (t) {
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate,
            s = r.selected,
            i = r.minDate,
            p = r.maxDate,
            l = r.preSelection,
            d = r.monthClassName,
            c = r.excludeDates,
            u = r.includeDates,
            f = d ? d(a) : void 0,
            h = We.default(a, t);
        return fe.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), f, {
          "react-datepicker__month--disabled": (i || p || c || u) && ir(h, e.props),
          "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
          "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && Ie.default(l) === t,
          "react-datepicker__month--in-range": pr(n, o, t, a),
          "react-datepicker__month--range-start": e.isRangeStartMonth(t),
          "react-datepicker__month--range-end": e.isRangeEndMonth(t),
          "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
        });
      }), bt(Pt(e), "getTabIndex", function (t) {
        var r = Ie.default(e.props.preSelection);
        return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
      }), bt(Pt(e), "getAriaLabel", function (t) {
        var r = e.props,
            a = r.chooseDayAriaLabelPrefix,
            n = void 0 === a ? "Choose" : a,
            o = r.disabledDayAriaLabelPrefix,
            s = void 0 === o ? "Not available" : o,
            i = r.day,
            p = We.default(i, t),
            l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
        return "".concat(l, " ").concat(Ft(p, "MMMM yyyy"));
      }), bt(Pt(e), "getQuarterClassNames", function (t) {
        var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate,
            s = r.selected,
            i = r.minDate,
            p = r.maxDate;
        return fe.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
          "react-datepicker__quarter--disabled": (i || p) && lr(Be.default(a, t), e.props),
          "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
          "react-datepicker__quarter--in-range": cr(n, o, t, a),
          "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
          "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
        });
      }), bt(Pt(e), "renderMonths", function () {
        var t = e.props,
            r = t.showFullMonthYearPicker,
            a = t.showTwoColumnMonthYearPicker,
            n = t.showFourColumnMonthYearPicker,
            o = t.locale,
            s = t.day,
            i = t.selected;
        return (n ? [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]] : a ? [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]] : [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]).map(function (t, a) {
          return ue.default.createElement("div", {
            className: "react-datepicker__month-wrapper",
            key: a
          }, t.map(function (t, a) {
            return ue.default.createElement("div", {
              ref: e.MONTH_REFS[t],
              key: a,
              onClick: function (r) {
                e.onMonthClick(r, t);
              },
              onKeyDown: function (r) {
                e.onMonthKeyDown(r, t);
              },
              tabIndex: e.getTabIndex(t),
              className: e.getMonthClassNames(t),
              role: "option",
              "aria-label": e.getAriaLabel(t),
              "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
              "aria-selected": e.isSelectedMonth(s, t, i)
            }, r ? rr(t, o) : ar(t, o));
          }));
        });
      }), bt(Pt(e), "renderQuarters", function () {
        var t = e.props,
            r = t.day,
            a = t.selected;
        return ue.default.createElement("div", {
          className: "react-datepicker__quarter-wrapper"
        }, [1, 2, 3, 4].map(function (t, n) {
          return ue.default.createElement("div", {
            key: n,
            role: "option",
            onClick: function (r) {
              e.onQuarterClick(r, t);
            },
            className: e.getQuarterClassNames(t),
            "aria-selected": e.isSelectedQuarter(r, t, a)
          }, nr(t, e.props.locale));
        }));
      }), bt(Pt(e), "getClassNames", function () {
        var t = e.props;
        t.day;
        var r = t.selectingDate,
            a = t.selectsStart,
            n = t.selectsEnd,
            o = t.showMonthYearPicker,
            s = t.showQuarterYearPicker;
        return fe.default("react-datepicker__month", {
          "react-datepicker__month--selecting-range": r && (a || n)
        }, {
          "react-datepicker__monthPicker": o
        }, {
          "react-datepicker__quarterPicker": s
        });
      }), e;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e = this.props,
            t = e.showMonthYearPicker,
            r = e.showQuarterYearPicker,
            a = e.day,
            n = e.ariaLabelPrefix,
            o = void 0 === n ? "month " : n;
        return ue.default.createElement("div", {
          className: this.getClassNames(),
          onMouseLeave: this.handleMouseLeave,
          "aria-label": "".concat(o, " ").concat(Ft(a, "yyyy-MM")),
          role: "listbox"
        }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
      }
    }]), r;
  }(ue.default.Component),
      Br = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      var e;
      gt(this, r);

      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

      return bt(Pt(e = t.call.apply(t, [this].concat(n))), "state", {
        height: null
      }), bt(Pt(e), "handleClick", function (t) {
        (e.props.minTime || e.props.maxTime) && mr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && hr(t, e.props) || e.props.onChange(t);
      }), bt(Pt(e), "isSelectedTime", function (t, r, a) {
        return e.props.selected && r === Ne.default(t) && a === Ee.default(t);
      }), bt(Pt(e), "liClasses", function (t, r, a) {
        var n = ["react-datepicker__time-list-item", e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0];
        return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && mr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && hr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Ne.default(t) + Ee.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
      }), bt(Pt(e), "handleOnKeyDown", function (t, r) {
        " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
      }), bt(Pt(e), "renderTimes", function () {
        for (var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Kt(Tt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function (e, t) {
          return e - t;
        }), i = e.props.selected || e.props.openToDate || Tt(), p = Ne.default(i), l = Ee.default(i), d = qe.default(Ae.default(n, l), p), c = 0; c < o; c++) {
          var u = ve.default(n, c * a);

          if (t.push(u), s) {
            var f = Sr(n, u, c, a, s);
            t = t.concat(f);
          }
        }

        return t.map(function (t, a) {
          return ue.default.createElement("li", {
            key: a,
            onClick: e.handleClick.bind(Pt(e), t),
            className: e.liClasses(t, p, l),
            ref: function (r) {
              (pt.default(t, d) || Xt(t, d)) && (e.centerLi = r);
            },
            onKeyDown: function (r) {
              e.handleOnKeyDown(r, t);
            },
            tabIndex: "0",
            "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
          }, Ft(t, r, e.props.locale));
        });
      }), e;
    }

    return kt(r, [{
      key: "componentDidMount",
      value: function () {
        this.list.scrollTop = this.centerLi && r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
          height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
      }
    }, {
      key: "render",
      value: function () {
        var e = this,
            t = this.state.height;
        return ue.default.createElement("div", {
          className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
        }, ue.default.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
          ref: function (t) {
            e.header = t;
          }
        }, ue.default.createElement("div", {
          className: "react-datepicker-time__header"
        }, this.props.timeCaption)), ue.default.createElement("div", {
          className: "react-datepicker__time"
        }, ue.default.createElement("div", {
          className: "react-datepicker__time-box"
        }, ue.default.createElement("ul", {
          className: "react-datepicker__time-list",
          ref: function (t) {
            e.list = t;
          },
          style: t ? {
            height: t
          } : {},
          tabIndex: "0"
        }, this.renderTimes()))));
      }
    }], [{
      key: "defaultProps",
      get: function () {
        return {
          intervals: 30,
          onTimeChange: function () {},
          todayButton: null,
          timeCaption: "Time"
        };
      }
    }]), r;
  }(ue.default.Component);

  bt(Br, "calcCenterPosition", function (e, t) {
    return t.offsetTop - (e / 2 - t.clientHeight / 2);
  });

  var Kr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), bt(Pt(a = t.call(this, e)), "YEAR_REFS", Ot(Array(a.props.yearItemNumber)).map(function () {
        return ue.default.createRef();
      })), bt(Pt(a), "isDisabled", function (e) {
        return or(e, a.props);
      }), bt(Pt(a), "isExcluded", function (e) {
        return sr(e, a.props);
      }), bt(Pt(a), "updateFocusOnPaginate", function (e) {
        var t = function () {
          this.YEAR_REFS[e].current.focus();
        }.bind(Pt(a));

        window.requestAnimationFrame(t);
      }), bt(Pt(a), "handleYearClick", function (e, t) {
        a.props.onDayClick && a.props.onDayClick(e, t);
      }), bt(Pt(a), "handleYearNavigation", function (e, t) {
        var r = a.props,
            n = r.date,
            o = r.yearItemNumber,
            s = _r(n, o).startPeriod;

        a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
      }), bt(Pt(a), "isSameDay", function (e, t) {
        return Jt(e, t);
      }), bt(Pt(a), "isCurrentYear", function (e) {
        return e === Le.default(Tt());
      }), bt(Pt(a), "isKeyboardSelected", function (e) {
        var t = Qt(Ke.default(a.props.date, e));
        return !a.props.disabledKeyboardNavigation && !a.props.inline && !Jt(t, Qt(a.props.selected)) && Jt(t, Qt(a.props.preSelection));
      }), bt(Pt(a), "onYearClick", function (e, t) {
        var r = a.props.date;
        a.handleYearClick(Qt(Ke.default(r, t)), e);
      }), bt(Pt(a), "onYearKeyDown", function (e, t) {
        var r = e.key;
        if (!a.props.disabledKeyboardNavigation) switch (r) {
          case "Enter":
            a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
            break;

          case "ArrowRight":
            a.handleYearNavigation(t + 1, be.default(a.props.preSelection, 1));
            break;

          case "ArrowLeft":
            a.handleYearNavigation(t - 1, Me.default(a.props.preSelection, 1));
        }
      }), bt(Pt(a), "getYearClassNames", function (e) {
        var t = a.props,
            r = t.minDate,
            n = t.maxDate,
            o = t.selected,
            s = t.excludeDates,
            i = t.includeDates,
            p = t.filterDate;
        return fe.default("react-datepicker__year-text", {
          "react-datepicker__year-text--selected": e === Le.default(o),
          "react-datepicker__year-text--disabled": (r || n || s || i || p) && dr(e, a.props),
          "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
          "react-datepicker__year-text--today": a.isCurrentYear(e)
        });
      }), bt(Pt(a), "getYearTabIndex", function (e) {
        return a.props.disabledKeyboardNavigation ? "-1" : e === Le.default(a.props.preSelection) ? "0" : "-1";
      }), a;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        for (var e = this, t = [], r = this.props, a = _r(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function (r) {
          t.push(ue.default.createElement("div", {
            ref: e.YEAR_REFS[r - n],
            onClick: function (t) {
              e.onYearClick(t, r);
            },
            onKeyDown: function (t) {
              e.onYearKeyDown(t, r);
            },
            tabIndex: e.getYearTabIndex(r),
            className: e.getYearClassNames(r),
            key: r,
            "aria-current": e.isCurrentYear(r) ? "date" : void 0
          }, r));
        }, i = n; i <= o; i++) s(i);

        return ue.default.createElement("div", {
          className: "react-datepicker__year"
        }, ue.default.createElement("div", {
          className: "react-datepicker__year-wrapper"
        }, t));
      }
    }]), r;
  }(ue.default.Component),
      jr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), bt(Pt(a = t.call(this, e)), "onTimeChange", function (e) {
        a.setState({
          time: e
        });
        var t = new Date();
        t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
      }), bt(Pt(a), "renderTimeInput", function () {
        var e = a.state.time,
            t = a.props,
            r = t.date,
            n = t.timeString,
            o = t.customTimeInput;
        return o ? ue.default.cloneElement(o, {
          date: r,
          value: e,
          onChange: a.onTimeChange
        }) : ue.default.createElement("input", {
          type: "time",
          className: "react-datepicker-time__input",
          placeholder: "Time",
          name: "time-input",
          required: !0,
          value: e,
          onChange: function (e) {
            a.onTimeChange(e.target.value || n);
          }
        });
      }), a.state = {
        time: a.props.timeString
      }, a;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        return ue.default.createElement("div", {
          className: "react-datepicker__input-time-container"
        }, ue.default.createElement("div", {
          className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), ue.default.createElement("div", {
          className: "react-datepicker-time__input-container"
        }, ue.default.createElement("div", {
          className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function (e, t) {
        return e.timeString !== t.time ? {
          time: e.timeString
        } : null;
      }
    }]), r;
  }(ue.default.Component);

  function Hr(e) {
    var t = e.className,
        r = e.children,
        a = e.showPopperArrow,
        n = e.arrowProps,
        o = void 0 === n ? {} : n;
    return ue.default.createElement("div", {
      className: t
    }, a && ue.default.createElement("div", St({
      className: "react-datepicker__triangle"
    }, o)), r);
  }

  var Qr = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"],
      Vr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), bt(Pt(a = t.call(this, e)), "handleClickOutside", function (e) {
        a.props.onClickOutside(e);
      }), bt(Pt(a), "setClickOutsideRef", function () {
        return a.containerRef.current;
      }), bt(Pt(a), "handleDropdownFocus", function (e) {
        (function () {
          var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
          return Qr.some(function (t) {
            return e.indexOf(t) >= 0;
          });
        })(e.target) && a.props.onDropdownFocus();
      }), bt(Pt(a), "getDateInView", function () {
        var e = a.props,
            t = e.preSelection,
            r = e.selected,
            n = e.openToDate,
            o = wr(a.props),
            s = kr(a.props),
            i = Tt(),
            p = n || r || t;
        return p || (o && pt.default(i, o) ? o : s && it.default(i, s) ? s : i);
      }), bt(Pt(a), "increaseMonth", function () {
        a.setState(function (e) {
          var t = e.date;
          return {
            date: ke.default(t, 1)
          };
        }, function () {
          return a.handleMonthChange(a.state.date);
        });
      }), bt(Pt(a), "decreaseMonth", function () {
        a.setState(function (e) {
          var t = e.date;
          return {
            date: _e.default(t, 1)
          };
        }, function () {
          return a.handleMonthChange(a.state.date);
        });
      }), bt(Pt(a), "handleDayClick", function (e, t, r) {
        a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
      }), bt(Pt(a), "handleDayMouseEnter", function (e) {
        a.setState({
          selectingDate: e
        }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
      }), bt(Pt(a), "handleMonthMouseLeave", function () {
        a.setState({
          selectingDate: null
        }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
      }), bt(Pt(a), "handleYearChange", function (e) {
        a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
      }), bt(Pt(a), "handleMonthChange", function (e) {
        a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
      }), bt(Pt(a), "handleMonthYearChange", function (e) {
        a.handleYearChange(e), a.handleMonthChange(e);
      }), bt(Pt(a), "changeYear", function (e) {
        a.setState(function (t) {
          var r = t.date;
          return {
            date: Ke.default(r, e)
          };
        }, function () {
          return a.handleYearChange(a.state.date);
        });
      }), bt(Pt(a), "changeMonth", function (e) {
        a.setState(function (t) {
          var r = t.date;
          return {
            date: We.default(r, e)
          };
        }, function () {
          return a.handleMonthChange(a.state.date);
        });
      }), bt(Pt(a), "changeMonthYear", function (e) {
        a.setState(function (t) {
          var r = t.date;
          return {
            date: Ke.default(We.default(r, Ie.default(e)), Le.default(e))
          };
        }, function () {
          return a.handleMonthYearChange(a.state.date);
        });
      }), bt(Pt(a), "header", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
            t = jt(e, a.props.locale, a.props.calendarStartDay),
            r = [];
        return a.props.showWeekNumbers && r.push(ue.default.createElement("div", {
          key: "W",
          className: "react-datepicker__day-name"
        }, a.props.weekLabel || "#")), r.concat([0, 1, 2, 3, 4, 5, 6].map(function (e) {
          var r = ge.default(t, e),
              n = a.formatWeekday(r, a.props.locale),
              o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
          return ue.default.createElement("div", {
            key: e,
            className: fe.default("react-datepicker__day-name", o)
          }, n);
        }));
      }), bt(Pt(a), "formatWeekday", function (e, t) {
        return a.props.formatWeekDay ? function (e, t, r) {
          return "function" == typeof t ? t(e, r) : Ft(e, "EEEE", r);
        }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function (e, t) {
          return Ft(e, "EEE", t);
        }(e, t) : function (e, t) {
          return Ft(e, "EEEEEE", t);
        }(e, t);
      }), bt(Pt(a), "decreaseYear", function () {
        a.setState(function (e) {
          var t = e.date;
          return {
            date: Me.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
          };
        }, function () {
          return a.handleYearChange(a.state.date);
        });
      }), bt(Pt(a), "renderPreviousButton", function () {
        if (!a.props.renderCustomHeader) {
          var e;

          switch (!0) {
            case a.props.showMonthYearPicker:
              e = Dr(a.state.date, a.props);
              break;

            case a.props.showYearPicker:
              e = function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.minDate,
                    a = t.yearItemNumber,
                    n = void 0 === a ? It : a,
                    o = _r(Qt(Me.default(e, n)), n).endPeriod,
                    s = r && Le.default(r);

                return s && s > o || !1;
              }(a.state.date, a.props);

              break;

            default:
              e = yr(a.state.date, a.props);
          }

          if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
            var t = ["react-datepicker__navigation", "react-datepicker__navigation--previous"],
                r = a.decreaseMonth;
            (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
            var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                o = a.props,
                s = o.previousMonthButtonLabel,
                i = o.previousYearButtonLabel,
                p = a.props,
                l = p.previousMonthAriaLabel,
                d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l,
                c = p.previousYearAriaLabel,
                u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
            return ue.default.createElement("button", {
              type: "button",
              className: t.join(" "),
              onClick: r,
              onKeyDown: a.props.handleOnKeyDown,
              "aria-label": n ? u : d
            }, ue.default.createElement("span", {
              className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ")
            }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
          }
        }
      }), bt(Pt(a), "increaseYear", function () {
        a.setState(function (e) {
          var t = e.date;
          return {
            date: be.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
          };
        }, function () {
          return a.handleYearChange(a.state.date);
        });
      }), bt(Pt(a), "renderNextButton", function () {
        if (!a.props.renderCustomHeader) {
          var e;

          switch (!0) {
            case a.props.showMonthYearPicker:
              e = gr(a.state.date, a.props);
              break;

            case a.props.showYearPicker:
              e = function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.maxDate,
                    a = t.yearItemNumber,
                    n = void 0 === a ? It : a,
                    o = _r(be.default(e, n), n).startPeriod,
                    s = r && Le.default(r);

                return s && s < o || !1;
              }(a.state.date, a.props);

              break;

            default:
              e = vr(a.state.date, a.props);
          }

          if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
            var t = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
            a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
            var r = a.increaseMonth;
            (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
            var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                o = a.props,
                s = o.nextMonthButtonLabel,
                i = o.nextYearButtonLabel,
                p = a.props,
                l = p.nextMonthAriaLabel,
                d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l,
                c = p.nextYearAriaLabel,
                u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
            return ue.default.createElement("button", {
              type: "button",
              className: t.join(" "),
              onClick: r,
              onKeyDown: a.props.handleOnKeyDown,
              "aria-label": n ? u : d
            }, ue.default.createElement("span", {
              className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ")
            }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
          }
        }
      }), bt(Pt(a), "renderCurrentMonth", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
            t = ["react-datepicker__current-month"];
        return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), ue.default.createElement("div", {
          className: t.join(" ")
        }, Ft(e, a.props.dateFormat, a.props.locale));
      }), bt(Pt(a), "renderYearDropdown", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (a.props.showYearDropdown && !e) return ue.default.createElement(Nr, {
          adjustDateOnChange: a.props.adjustDateOnChange,
          date: a.state.date,
          onSelect: a.props.onSelect,
          setOpen: a.props.setOpen,
          dropdownMode: a.props.dropdownMode,
          onChange: a.changeYear,
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          year: Le.default(a.state.date),
          scrollableYearDropdown: a.props.scrollableYearDropdown,
          yearDropdownItemNumber: a.props.yearDropdownItemNumber
        });
      }), bt(Pt(a), "renderMonthDropdown", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (a.props.showMonthDropdown && !e) return ue.default.createElement(Yr, {
          dropdownMode: a.props.dropdownMode,
          locale: a.props.locale,
          onChange: a.changeMonth,
          month: Ie.default(a.state.date),
          useShortMonthInDropdown: a.props.useShortMonthInDropdown
        });
      }), bt(Pt(a), "renderMonthYearDropdown", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (a.props.showMonthYearDropdown && !e) return ue.default.createElement(Rr, {
          dropdownMode: a.props.dropdownMode,
          locale: a.props.locale,
          dateFormat: a.props.dateFormat,
          onChange: a.changeMonthYear,
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          date: a.state.date,
          scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
        });
      }), bt(Pt(a), "handleTodayButtonClick", function (e) {
        a.props.onSelect(Ut(), e), a.props.setPreSelection && a.props.setPreSelection(Ut());
      }), bt(Pt(a), "renderTodayButton", function () {
        if (a.props.todayButton && !a.props.showTimeSelectOnly) return ue.default.createElement("div", {
          className: "react-datepicker__today-button",
          onClick: function (e) {
            return a.handleTodayButtonClick(e);
          }
        }, a.props.todayButton);
      }), bt(Pt(a), "renderDefaultHeader", function (e) {
        var t = e.monthDate,
            r = e.i;
        return ue.default.createElement("div", {
          className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
        }, a.renderCurrentMonth(t), ue.default.createElement("div", {
          className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
          onFocus: a.handleDropdownFocus
        }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), ue.default.createElement("div", {
          className: "react-datepicker__day-names"
        }, a.header(t)));
      }), bt(Pt(a), "renderCustomHeader", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.monthDate,
            r = e.i;
        if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
        var n = yr(a.state.date, a.props),
            o = vr(a.state.date, a.props),
            s = Dr(a.state.date, a.props),
            i = gr(a.state.date, a.props),
            p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
        return ue.default.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: a.props.onDropdownFocus
        }, a.props.renderCustomHeader(vt(vt({}, a.state), {}, {
          customHeaderCount: r,
          monthDate: t,
          changeMonth: a.changeMonth,
          changeYear: a.changeYear,
          decreaseMonth: a.decreaseMonth,
          increaseMonth: a.increaseMonth,
          decreaseYear: a.decreaseYear,
          increaseYear: a.increaseYear,
          prevMonthButtonDisabled: n,
          nextMonthButtonDisabled: o,
          prevYearButtonDisabled: s,
          nextYearButtonDisabled: i
        })), p && ue.default.createElement("div", {
          className: "react-datepicker__day-names"
        }, a.header(t)));
      }), bt(Pt(a), "renderYearHeader", function () {
        var e = a.state.date,
            t = a.props,
            r = t.showYearPicker,
            n = _r(e, t.yearItemNumber),
            o = n.startPeriod,
            s = n.endPeriod;

        return ue.default.createElement("div", {
          className: "react-datepicker__header react-datepicker-year-header"
        }, r ? "".concat(o, " - ").concat(s) : Le.default(e));
      }), bt(Pt(a), "renderHeader", function (e) {
        switch (!0) {
          case void 0 !== a.props.renderCustomHeader:
            return a.renderCustomHeader(e);

          case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
            return a.renderYearHeader(e);

          default:
            return a.renderDefaultHeader(e);
        }
      }), bt(Pt(a), "renderMonths", function () {
        if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
          for (var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = _e.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n) {
            var o = n - a.props.monthSelectedIn,
                s = ke.default(r, o),
                i = "month-".concat(n),
                p = n < a.props.monthsShown - 1,
                l = n > 0;
            e.push(ue.default.createElement("div", {
              key: i,
              ref: function (e) {
                a.monthContainer = e;
              },
              className: "react-datepicker__month-container"
            }, a.renderHeader({
              monthDate: s,
              i: n
            }), ue.default.createElement(Wr, {
              chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
              disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
              weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
              ariaLabelPrefix: a.props.monthAriaLabelPrefix,
              onChange: a.changeMonthYear,
              day: s,
              dayClassName: a.props.dayClassName,
              calendarStartDay: a.props.calendarStartDay,
              monthClassName: a.props.monthClassName,
              onDayClick: a.handleDayClick,
              handleOnKeyDown: a.props.handleOnDayKeyDown,
              onDayMouseEnter: a.handleDayMouseEnter,
              onMouseLeave: a.handleMonthMouseLeave,
              onWeekSelect: a.props.onWeekSelect,
              orderInDisplay: n,
              formatWeekNumber: a.props.formatWeekNumber,
              locale: a.props.locale,
              minDate: a.props.minDate,
              maxDate: a.props.maxDate,
              excludeDates: a.props.excludeDates,
              excludeDateIntervals: a.props.excludeDateIntervals,
              highlightDates: a.props.highlightDates,
              selectingDate: a.state.selectingDate,
              includeDates: a.props.includeDates,
              includeDateIntervals: a.props.includeDateIntervals,
              inline: a.props.inline,
              shouldFocusDayInline: a.props.shouldFocusDayInline,
              fixedHeight: a.props.fixedHeight,
              filterDate: a.props.filterDate,
              preSelection: a.props.preSelection,
              setPreSelection: a.props.setPreSelection,
              selected: a.props.selected,
              selectsStart: a.props.selectsStart,
              selectsEnd: a.props.selectsEnd,
              selectsRange: a.props.selectsRange,
              selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
              showWeekNumbers: a.props.showWeekNumbers,
              startDate: a.props.startDate,
              endDate: a.props.endDate,
              peekNextMonth: a.props.peekNextMonth,
              setOpen: a.props.setOpen,
              shouldCloseOnSelect: a.props.shouldCloseOnSelect,
              renderDayContents: a.props.renderDayContents,
              disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
              showMonthYearPicker: a.props.showMonthYearPicker,
              showFullMonthYearPicker: a.props.showFullMonthYearPicker,
              showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
              showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
              showYearPicker: a.props.showYearPicker,
              showQuarterYearPicker: a.props.showQuarterYearPicker,
              isInputFocused: a.props.isInputFocused,
              containerRef: a.containerRef,
              monthShowsDuplicateDaysEnd: p,
              monthShowsDuplicateDaysStart: l
            })));
          }

          return e;
        }
      }), bt(Pt(a), "renderYears", function () {
        if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? ue.default.createElement("div", {
          className: "react-datepicker__year--container"
        }, a.renderHeader(), ue.default.createElement(Kr, St({
          onDayClick: a.handleDayClick,
          date: a.state.date
        }, a.props))) : void 0;
      }), bt(Pt(a), "renderTimeSection", function () {
        if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return ue.default.createElement(Br, {
          selected: a.props.selected,
          openToDate: a.props.openToDate,
          onChange: a.props.onTimeChange,
          timeClassName: a.props.timeClassName,
          format: a.props.timeFormat,
          includeTimes: a.props.includeTimes,
          intervals: a.props.timeIntervals,
          minTime: a.props.minTime,
          maxTime: a.props.maxTime,
          excludeTimes: a.props.excludeTimes,
          filterTime: a.props.filterTime,
          timeCaption: a.props.timeCaption,
          todayButton: a.props.todayButton,
          showMonthDropdown: a.props.showMonthDropdown,
          showMonthYearDropdown: a.props.showMonthYearDropdown,
          showYearDropdown: a.props.showYearDropdown,
          withPortal: a.props.withPortal,
          monthRef: a.state.monthContainer,
          injectTimes: a.props.injectTimes,
          locale: a.props.locale,
          handleOnKeyDown: a.props.handleOnKeyDown,
          showTimeSelectOnly: a.props.showTimeSelectOnly
        });
      }), bt(Pt(a), "renderInputTimeSection", function () {
        var e = new Date(a.props.selected),
            t = Rt(e) && Boolean(a.props.selected) ? "".concat(Cr(e.getHours()), ":").concat(Cr(e.getMinutes())) : "";
        if (a.props.showTimeInput) return ue.default.createElement(jr, {
          date: e,
          timeString: t,
          timeInputLabel: a.props.timeInputLabel,
          onChange: a.props.onTimeChange,
          customTimeInput: a.props.customTimeInput
        });
      }), bt(Pt(a), "renderChildren", function () {
        if (a.props.children) return ue.default.createElement("div", {
          className: "react-datepicker__children-container"
        }, a.props.children);
      }), a.containerRef = ue.default.createRef(), a.state = {
        date: a.getDateInView(),
        selectingDate: null,
        monthContainer: null
      }, a;
    }

    return kt(r, [{
      key: "componentDidMount",
      value: function () {
        var e = this;
        this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
          monthContainer: e.monthContainer
        }));
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        this.props.preSelection && !Jt(this.props.preSelection, e.preSelection) ? this.setState({
          date: this.props.preSelection
        }) : this.props.openToDate && !Jt(this.props.openToDate, e.openToDate) && this.setState({
          date: this.props.openToDate
        });
      }
    }, {
      key: "render",
      value: function () {
        var e = this.props.container || Hr;
        return ue.default.createElement("div", {
          ref: this.containerRef
        }, ue.default.createElement(e, {
          className: fe.default("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }),
          showPopperArrow: this.props.showPopperArrow,
          arrowProps: this.props.arrowProps
        }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
      }
    }], [{
      key: "defaultProps",
      get: function () {
        return {
          onDropdownFocus: function () {},
          monthsShown: 1,
          monthSelectedIn: 0,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          customTimeInput: null,
          yearItemNumber: It
        };
      }
    }]), r;
  }(ue.default.Component),
      Ur = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
    }

    return kt(r, [{
      key: "componentDidMount",
      value: function () {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.portalRoot.removeChild(this.el);
      }
    }, {
      key: "render",
      value: function () {
        return ht.default.createPortal(this.props.children, this.el);
      }
    }]), r;
  }(ue.default.Component),
      $r = function (e) {
    return !e.disabled && -1 !== e.tabIndex;
  },
      zr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), bt(Pt(a = t.call(this, e)), "getTabChildren", function () {
        return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter($r);
      }), bt(Pt(a), "handleFocusStart", function (e) {
        var t = a.getTabChildren();
        t && t.length > 1 && t[t.length - 1].focus();
      }), bt(Pt(a), "handleFocusEnd", function (e) {
        var t = a.getTabChildren();
        t && t.length > 1 && t[0].focus();
      }), a.tabLoopRef = ue.default.createRef(), a;
    }

    return kt(r, [{
      key: "render",
      value: function () {
        return this.props.enableTabLoop ? ue.default.createElement("div", {
          className: "react-datepicker__tab-loop",
          ref: this.tabLoopRef
        }, ue.default.createElement("div", {
          className: "react-datepicker__tab-loop__start",
          tabIndex: "0",
          onFocus: this.handleFocusStart
        }), this.props.children, ue.default.createElement("div", {
          className: "react-datepicker__tab-loop__end",
          tabIndex: "0",
          onFocus: this.handleFocusEnd
        })) : this.props.children;
      }
    }], [{
      key: "defaultProps",
      get: function () {
        return {
          enableTabLoop: !0
        };
      }
    }]), r;
  }(ue.default.Component),
      Gr = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r() {
      return gt(this, r), t.apply(this, arguments);
    }

    return kt(r, [{
      key: "render",
      value: function () {
        var e,
            t = this.props,
            r = t.className,
            a = t.wrapperClassName,
            n = t.hidePopper,
            o = t.popperComponent,
            s = t.popperModifiers,
            i = t.popperPlacement,
            p = t.popperProps,
            l = t.targetComponent,
            d = t.enableTabLoop,
            c = t.popperOnKeyDown,
            u = t.portalId,
            f = t.portalHost;

        if (!n) {
          var h = fe.default("react-datepicker-popper", r);
          e = ue.default.createElement(le.Popper, St({
            modifiers: s,
            placement: i
          }, p), function (e) {
            var t = e.ref,
                r = e.style,
                a = e.placement,
                n = e.arrowProps;
            return ue.default.createElement(zr, {
              enableTabLoop: d
            }, ue.default.createElement("div", {
              ref: t,
              style: r,
              className: h,
              "data-placement": a,
              onKeyDown: c
            }, ue.default.cloneElement(o, {
              arrowProps: n
            })));
          });
        }

        this.props.popperContainer && (e = ue.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = ue.default.createElement(Ur, {
          portalId: u,
          portalHost: f
        }, e));
        var m = fe.default("react-datepicker-wrapper", a);
        return ue.default.createElement(le.Manager, {
          className: "react-datepicker-manager"
        }, ue.default.createElement(le.Reference, null, function (e) {
          var t = e.ref;
          return ue.default.createElement("div", {
            ref: t,
            className: m
          }, l);
        }), e);
      }
    }], [{
      key: "defaultProps",
      get: function () {
        return {
          hidePopper: !0,
          popperModifiers: [],
          popperProps: {},
          popperPlacement: "bottom-start"
        };
      }
    }]), r;
  }(ue.default.Component),
      Jr = "react-datepicker-ignore-onclickoutside",
      Xr = ft.default(Vr);

  var Zr = "Date input not valid.",
      ea = function (e) {
    Ct(r, e);
    var t = Nt(r);

    function r(e) {
      var a;
      return gt(this, r), bt(Pt(a = t.call(this, e)), "getPreSelection", function () {
        return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Tt();
      }), bt(Pt(a), "calcInitialState", function () {
        var e,
            t = a.getPreSelection(),
            r = wr(a.props),
            n = kr(a.props),
            o = r && pt.default(t, $e.default(r)) ? r : n && it.default(t, Ze.default(n)) ? n : t;
        return {
          open: a.props.startOpen || !1,
          preventFocus: !1,
          preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
          highlightDates: br(a.props.highlightDates),
          focused: !1,
          shouldFocusDayInline: !1
        };
      }), bt(Pt(a), "clearPreventFocusTimeout", function () {
        a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
      }), bt(Pt(a), "setFocus", function () {
        a.input && a.input.focus && a.input.focus({
          preventScroll: !0
        });
      }), bt(Pt(a), "setBlur", function () {
        a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
      }), bt(Pt(a), "setOpen", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        a.setState({
          open: e,
          preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
          lastPreSelectChange: ra
        }, function () {
          e || a.setState(function (e) {
            return {
              focused: !!t && e.focused
            };
          }, function () {
            !t && a.setBlur(), a.setState({
              inputValue: null
            });
          });
        });
      }), bt(Pt(a), "inputOk", function () {
        return he.default(a.state.preSelection);
      }), bt(Pt(a), "isCalendarOpen", function () {
        return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
      }), bt(Pt(a), "handleFocus", function (e) {
        a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
          focused: !0
        });
      }), bt(Pt(a), "cancelFocusInput", function () {
        clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
      }), bt(Pt(a), "deferFocusInput", function () {
        a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function () {
          return a.setFocus();
        }, 1);
      }), bt(Pt(a), "handleDropdownFocus", function () {
        a.cancelFocusInput();
      }), bt(Pt(a), "handleBlur", function (e) {
        (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
          focused: !1
        });
      }), bt(Pt(a), "handleCalendarClickOutside", function (e) {
        a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
      }), bt(Pt(a), "handleChange", function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

        var n = t[0];

        if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(Pt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
          a.setState({
            inputValue: n.target.value,
            lastPreSelectChange: ta
          });
          var o = Lt(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.selected, a.props.minDate);
          a.props.showTimeSelectOnly && !Jt(o, a.props.selected) && (o = mt.default(a.props.selected, {
            hours: Ne.default(o),
            minutes: Ee.default(o),
            seconds: Pe.default(o)
          })), !o && n.target.value || a.setSelected(o, n, !0);
        }
      }), bt(Pt(a), "handleSelect", function (e, t, r) {
        if (a.setState({
          preventFocus: !0
        }, function () {
          return a.preventFocusTimeout = setTimeout(function () {
            return a.setState({
              preventFocus: !1
            });
          }, 50), a.preventFocusTimeout;
        }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);else if (!a.props.inline) {
          a.props.selectsRange || a.setOpen(!1);
          var n = a.props,
              o = n.startDate,
              s = n.endDate;
          !o || s || pt.default(e, o) || a.setOpen(!1);
        }
      }), bt(Pt(a), "setSelected", function (e, t, r, n) {
        var o = e;

        if (a.props.showYearPicker) {
          if (null !== o && dr(Le.default(o), a.props)) return;
        } else if (a.props.showMonthYearPicker) {
          if (null !== o && ir(o, a.props)) return;
        } else if (null !== o && or(o, a.props)) return;

        var s = a.props,
            i = s.onChange,
            p = s.selectsRange,
            l = s.startDate,
            d = s.endDate;
        if (!Xt(a.props.selected, o) || a.props.allowSameDay || p) if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = qt(o, {
          hour: Ne.default(a.props.selected),
          minute: Ee.default(a.props.selected),
          second: Pe.default(a.props.selected)
        })), a.props.inline || a.setState({
          preSelection: o
        }), a.props.focusSelectedMonth || a.setState({
          monthSelectedIn: n
        })), p) {
          var c = l && !d,
              u = l && d;
          !l && !d ? i([o, null], t) : c && (pt.default(o, l) ? i([o, null], t) : i([l, o], t)), u && i([o, null], t);
        } else i(o, t);
        r || (a.props.onSelect(o, t), a.setState({
          inputValue: null
        }));
      }), bt(Pt(a), "setPreSelection", function (e) {
        var t = void 0 !== a.props.minDate,
            r = void 0 !== a.props.maxDate,
            n = !0;

        if (e) {
          var o = $e.default(e);
          if (t && r) n = Zt(e, a.props.minDate, a.props.maxDate);else if (t) {
            var s = $e.default(a.props.minDate);
            n = it.default(e, s) || Xt(o, s);
          } else if (r) {
            var i = Ze.default(a.props.maxDate);
            n = pt.default(e, i) || Xt(o, i);
          }
        }

        n && a.setState({
          preSelection: e
        });
      }), bt(Pt(a), "handleTimeChange", function (e) {
        var t = qt(a.props.selected ? a.props.selected : a.getPreSelection(), {
          hour: Ne.default(e),
          minute: Ee.default(e)
        });
        a.setState({
          preSelection: t
        }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
          inputValue: null
        });
      }), bt(Pt(a), "onInputClick", function () {
        a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
      }), bt(Pt(a), "onInputKeyDown", function (e) {
        a.props.onKeyDown(e);
        var t = e.key;

        if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
          if (a.state.open) {
            if ("ArrowDown" === t || "ArrowUp" === t) {
              e.preventDefault();
              var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
              return void (r && r.focus({
                preventScroll: !0
              }));
            }

            var n = Tt(a.state.preSelection);
            "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === ra ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
              code: 1,
              msg: Zr
            });
          }
        } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
      }), bt(Pt(a), "onPortalKeyDown", function (e) {
        "Escape" === e.key && (e.preventDefault(), a.setState({
          preventFocus: !0
        }, function () {
          a.setOpen(!1), setTimeout(function () {
            a.setFocus(), a.setState({
              preventFocus: !1
            });
          });
        }));
      }), bt(Pt(a), "onDayKeyDown", function (e) {
        a.props.onKeyDown(e);
        var t = e.key,
            r = Tt(a.state.preSelection);
        if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
          code: 1,
          msg: Zr
        });else if (!a.props.disabledKeyboardNavigation) {
          var n;

          switch (t) {
            case "ArrowLeft":
              n = Se.default(r, 1);
              break;

            case "ArrowRight":
              n = ge.default(r, 1);
              break;

            case "ArrowUp":
              n = Ce.default(r, 1);
              break;

            case "ArrowDown":
              n = we.default(r, 1);
              break;

            case "PageUp":
              n = _e.default(r, 1);
              break;

            case "PageDown":
              n = ke.default(r, 1);
              break;

            case "Home":
              n = Me.default(r, 1);
              break;

            case "End":
              n = be.default(r, 1);
          }

          if (!n) return void (a.props.onInputError && a.props.onInputError({
            code: 1,
            msg: Zr
          }));

          if (e.preventDefault(), a.setState({
            lastPreSelectChange: ra
          }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
            var o = Ie.default(r),
                s = Ie.default(n),
                i = Le.default(r),
                p = Le.default(n);
            o !== s || i !== p ? a.setState({
              shouldFocusDayInline: !0
            }) : a.setState({
              shouldFocusDayInline: !1
            });
          }
        }
      }), bt(Pt(a), "onPopperKeyDown", function (e) {
        "Escape" === e.key && (e.preventDefault(), a.setState({
          preventFocus: !0
        }, function () {
          a.setOpen(!1), setTimeout(function () {
            a.setFocus(), a.setState({
              preventFocus: !1
            });
          });
        }));
      }), bt(Pt(a), "onClearClick", function (e) {
        e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([null, null], e) : a.props.onChange(null, e), a.setState({
          inputValue: null
        });
      }), bt(Pt(a), "clear", function () {
        a.onClearClick();
      }), bt(Pt(a), "onScroll", function (e) {
        "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
      }), bt(Pt(a), "renderCalendar", function () {
        return a.props.inline || a.isCalendarOpen() ? ue.default.createElement(Xr, {
          ref: function (e) {
            a.calendar = e;
          },
          locale: a.props.locale,
          calendarStartDay: a.props.calendarStartDay,
          chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
          weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
          monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
          adjustDateOnChange: a.props.adjustDateOnChange,
          setOpen: a.setOpen,
          shouldCloseOnSelect: a.props.shouldCloseOnSelect,
          dateFormat: a.props.dateFormatCalendar,
          useWeekdaysShort: a.props.useWeekdaysShort,
          formatWeekDay: a.props.formatWeekDay,
          dropdownMode: a.props.dropdownMode,
          selected: a.props.selected,
          preSelection: a.state.preSelection,
          onSelect: a.handleSelect,
          onWeekSelect: a.props.onWeekSelect,
          openToDate: a.props.openToDate,
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          selectsStart: a.props.selectsStart,
          selectsEnd: a.props.selectsEnd,
          selectsRange: a.props.selectsRange,
          startDate: a.props.startDate,
          endDate: a.props.endDate,
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals,
          filterDate: a.props.filterDate,
          onClickOutside: a.handleCalendarClickOutside,
          formatWeekNumber: a.props.formatWeekNumber,
          highlightDates: a.state.highlightDates,
          includeDates: a.props.includeDates,
          includeDateIntervals: a.props.includeDateIntervals,
          includeTimes: a.props.includeTimes,
          injectTimes: a.props.injectTimes,
          inline: a.props.inline,
          shouldFocusDayInline: a.state.shouldFocusDayInline,
          peekNextMonth: a.props.peekNextMonth,
          showMonthDropdown: a.props.showMonthDropdown,
          showPreviousMonths: a.props.showPreviousMonths,
          useShortMonthInDropdown: a.props.useShortMonthInDropdown,
          showMonthYearDropdown: a.props.showMonthYearDropdown,
          showWeekNumbers: a.props.showWeekNumbers,
          showYearDropdown: a.props.showYearDropdown,
          withPortal: a.props.withPortal,
          forceShowMonthNavigation: a.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
          scrollableYearDropdown: a.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
          todayButton: a.props.todayButton,
          weekLabel: a.props.weekLabel,
          outsideClickIgnoreClass: Jr,
          fixedHeight: a.props.fixedHeight,
          monthsShown: a.props.monthsShown,
          monthSelectedIn: a.state.monthSelectedIn,
          onDropdownFocus: a.handleDropdownFocus,
          onMonthChange: a.props.onMonthChange,
          onYearChange: a.props.onYearChange,
          dayClassName: a.props.dayClassName,
          weekDayClassName: a.props.weekDayClassName,
          monthClassName: a.props.monthClassName,
          timeClassName: a.props.timeClassName,
          showTimeSelect: a.props.showTimeSelect,
          showTimeSelectOnly: a.props.showTimeSelectOnly,
          onTimeChange: a.handleTimeChange,
          timeFormat: a.props.timeFormat,
          timeIntervals: a.props.timeIntervals,
          minTime: a.props.minTime,
          maxTime: a.props.maxTime,
          excludeTimes: a.props.excludeTimes,
          filterTime: a.props.filterTime,
          timeCaption: a.props.timeCaption,
          className: a.props.calendarClassName,
          container: a.props.calendarContainer,
          yearItemNumber: a.props.yearItemNumber,
          yearDropdownItemNumber: a.props.yearDropdownItemNumber,
          previousMonthAriaLabel: a.props.previousMonthAriaLabel,
          previousMonthButtonLabel: a.props.previousMonthButtonLabel,
          nextMonthAriaLabel: a.props.nextMonthAriaLabel,
          nextMonthButtonLabel: a.props.nextMonthButtonLabel,
          previousYearAriaLabel: a.props.previousYearAriaLabel,
          previousYearButtonLabel: a.props.previousYearButtonLabel,
          nextYearAriaLabel: a.props.nextYearAriaLabel,
          nextYearButtonLabel: a.props.nextYearButtonLabel,
          timeInputLabel: a.props.timeInputLabel,
          disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
          renderCustomHeader: a.props.renderCustomHeader,
          popperProps: a.props.popperProps,
          renderDayContents: a.props.renderDayContents,
          onDayMouseEnter: a.props.onDayMouseEnter,
          onMonthMouseLeave: a.props.onMonthMouseLeave,
          selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
          showTimeInput: a.props.showTimeInput,
          showMonthYearPicker: a.props.showMonthYearPicker,
          showFullMonthYearPicker: a.props.showFullMonthYearPicker,
          showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
          showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
          showYearPicker: a.props.showYearPicker,
          showQuarterYearPicker: a.props.showQuarterYearPicker,
          showPopperArrow: a.props.showPopperArrow,
          excludeScrollbar: a.props.excludeScrollbar,
          handleOnKeyDown: a.props.onKeyDown,
          handleOnDayKeyDown: a.onDayKeyDown,
          isInputFocused: a.state.focused,
          customTimeInput: a.props.customTimeInput,
          setPreSelection: a.setPreSelection
        }, a.props.children) : null;
      }), bt(Pt(a), "renderDateInput", function () {
        var e,
            t = fe.default(a.props.className, bt({}, Jr, a.state.open)),
            r = a.props.customInput || ue.default.createElement("input", {
          type: "text"
        }),
            n = a.props.customInputRef || "ref",
            o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function (e, t, r) {
          if (!e) return "";
          var a = At(e, r),
              n = t ? At(t, r) : "";
          return "".concat(a, " - ").concat(n);
        }(a.props.startDate, a.props.endDate, a.props) : At(a.props.selected, a.props);
        return ue.default.cloneElement(r, (bt(e = {}, n, function (e) {
          a.input = e;
        }), bt(e, "value", o), bt(e, "onBlur", a.handleBlur), bt(e, "onChange", a.handleChange), bt(e, "onClick", a.onInputClick), bt(e, "onFocus", a.handleFocus), bt(e, "onKeyDown", a.onInputKeyDown), bt(e, "id", a.props.id), bt(e, "name", a.props.name), bt(e, "form", a.props.form), bt(e, "autoFocus", a.props.autoFocus), bt(e, "placeholder", a.props.placeholderText), bt(e, "disabled", a.props.disabled), bt(e, "autoComplete", a.props.autoComplete), bt(e, "className", fe.default(r.props.className, t)), bt(e, "title", a.props.title), bt(e, "readOnly", a.props.readOnly), bt(e, "required", a.props.required), bt(e, "tabIndex", a.props.tabIndex), bt(e, "aria-describedby", a.props.ariaDescribedBy), bt(e, "aria-invalid", a.props.ariaInvalid), bt(e, "aria-labelledby", a.props.ariaLabelledBy), bt(e, "aria-required", a.props.ariaRequired), e));
      }), bt(Pt(a), "renderClearButton", function () {
        var e = a.props,
            t = e.isClearable,
            r = e.selected,
            n = e.startDate,
            o = e.endDate,
            s = e.clearButtonTitle,
            i = e.clearButtonClassName,
            p = void 0 === i ? "" : i,
            l = e.ariaLabelClose,
            d = void 0 === l ? "Close" : l;
        return !t || null == r && null == n && null == o ? null : ue.default.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon ".concat(p).trim(),
          "aria-label": d,
          onClick: a.onClearClick,
          title: s,
          tabIndex: -1
        });
      }), a.state = a.calcInitialState(), a;
    }

    return kt(r, [{
      key: "componentDidMount",
      value: function () {
        window.addEventListener("scroll", this.onScroll, !0);
      }
    }, {
      key: "componentDidUpdate",
      value: function (e, t) {
        var r, a;
        e.inline && (r = e.selected, a = this.props.selected, r && a ? Ie.default(r) !== Ie.default(a) || Le.default(r) !== Le.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
          monthSelectedIn: 0
        }), e.highlightDates !== this.props.highlightDates && this.setState({
          highlightDates: br(this.props.highlightDates)
        }), t.focused || Xt(e.selected, this.props.selected) || this.setState({
          inputValue: null
        }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
      }
    }, {
      key: "renderInputContainer",
      value: function () {
        return ue.default.createElement("div", {
          className: "react-datepicker__input-container"
        }, this.renderDateInput(), this.renderClearButton());
      }
    }, {
      key: "render",
      value: function () {
        var e = this.renderCalendar();
        if (this.props.inline) return e;

        if (this.props.withPortal) {
          var t = this.state.open ? ue.default.createElement(zr, {
            enableTabLoop: this.props.enableTabLoop
          }, ue.default.createElement("div", {
            className: "react-datepicker__portal",
            tabIndex: -1,
            onKeyDown: this.onPortalKeyDown
          }, e)) : null;
          return this.state.open && this.props.portalId && (t = ue.default.createElement(Ur, {
            portalId: this.props.portalId,
            portalHost: this.props.portalHost
          }, t)), ue.default.createElement("div", null, this.renderInputContainer(), t);
        }

        return ue.default.createElement(Gr, {
          className: this.props.popperClassName,
          wrapperClassName: this.props.wrapperClassName,
          hidePopper: !this.isCalendarOpen(),
          portalId: this.props.portalId,
          portalHost: this.props.portalHost,
          popperModifiers: this.props.popperModifiers,
          targetComponent: this.renderInputContainer(),
          popperContainer: this.props.popperContainer,
          popperComponent: e,
          popperPlacement: this.props.popperPlacement,
          popperProps: this.props.popperProps,
          popperOnKeyDown: this.onPopperKeyDown,
          enableTabLoop: this.props.enableTabLoop
        });
      }
    }], [{
      key: "defaultProps",
      get: function () {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          onChange: function () {},
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          onFocus: function () {},
          onBlur: function () {},
          onKeyDown: function () {},
          onInputClick: function () {},
          onSelect: function () {},
          onClickOutside: function () {},
          onMonthChange: function () {},
          onCalendarOpen: function () {},
          onCalendarClose: function () {},
          preventOpenOnFocus: !1,
          onYearChange: function () {},
          onInputError: function () {},
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          strictParsing: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: It,
          renderDayContents: function (e) {
            return e;
          },
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0
        };
      }
    }]), r;
  }(ue.default.Component),
      ta = "input",
      ra = "navigate";

  e.CalendarContainer = Hr, e.default = ea, e.getDefaultLocale = er, e.registerLocale = function (e, t) {
    var r = "undefined" != typeof window ? window : globalThis;
    r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
  }, e.setDefaultLocale = function (e) {
    ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});